<script lang="ts" setup>
interface Props {
  size: number
}

defineProps<Props>()
</script>

<template>
  <div class="grid gap-2">
    <div
      v-for="item in size"
      :key="item"
      class="grid w-full gap-1 @lg:grid-cols-[13%,62%,17%,7%]"
    >
      <div class="h-24 animate-pulse bg-gray-200" />
      <div class="h-24 animate-pulse bg-gray-200" />
      <div class="h-24 animate-pulse bg-gray-200" />
      <div class="h-24 animate-pulse bg-gray-200" />
    </div>
  </div>
</template>
